/**
 * GroupApiModule - sl-jsx3.16.2: Group CRUD + Member Management API
 *
 * Provides GraphQL-based group management for workspace settings.
 */
import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { WorkspaceScope } from '../workspace';
import { GroupApiService } from './services/group-api';

export type { GroupData, GroupMemberData } from './services/group-api';
export { GroupApiService } from './services/group-api';

export function configureGroupApiModule(framework: Framework) {
  framework
    .scope(WorkspaceScope)
    .service(GroupApiService, [WorkspaceServerService]);
}
